import { createAPI } from '@common'
export default {
  // 增加敏感词
  postSensitiveAdd: config => createAPI('customEncryptApiName-1/0w20tfotjujwf0bee', 'POST', config),
  // 导入敏感词
  postSensitiveAddBatch: config => createAPI('customEncryptApiName-1/0w20tfotjujwf0beeCbudi', 'POST', config)
}
